export default "__VITE_ASSET__B2sOKu8M__"